import * as moment from "moment";

export class MomentDateHelper{
    public static formatYMD(date: moment.Moment): string
    {
        return date.format('YYYY-MM-DD')
    }
}